import { generate_random_color } from "#shared/utility_functions/color_functions";
import {
  checkIfValidDate,
  checkIfTimesAreMoreThan5MinutesApart,
} from "#shared/stringConditionals";
import { validateFileInterval } from "@src/utility_functions/inputValidation/validateFileInterval";
import { addMinutesToDate } from "@src/utility_functions/utility_functions/date_functions";
// Rows with no DELIVERY_TIME ("\N") get a synthetic delivery this long
// after CREATED_AT.
const DELIVERY_TIME_BACKFILL_MINUTES = 30;

export const parseCSVDataIntoIntervalsDoordash = async (
  data,
  setParsedItemCount,
  setFileError,
) => {
  const timelineDataObject = [];
  const colorMatchObject = {};
  let currentInterval = null;
  let runningDescription = "";
  let runningPrice = 0;
  let totalSpent = 0;
  let errors = 0;

  for (let index = 0; index < data.length; index++) {
    setParsedItemCount((prev) => {
      return prev + 1;
    });

    const item = data[index];
    // Guard Number() so a non-numeric UNIT_PRICE can't poison the running totals
    // with NaN.
    totalSpent += Number(item.UNIT_PRICE) || 0;
    let isNewOrder = true;
    let nextOrderIsNew = false;
    if (index > 0) {
      const previousDate = new Date(data[index - 1].CREATED_AT);
      const currentDate = new Date(item.CREATED_AT);
      isNewOrder = checkIfTimesAreMoreThan5MinutesApart(
        currentDate,
        previousDate,
      );
    }
    if (index === data.length - 1) {
      nextOrderIsNew = true;
    } else {
      const nextDate = new Date(data[index + 1].CREATED_AT);
      const currentDate = new Date(item.CREATED_AT);
      nextOrderIsNew = checkIfTimesAreMoreThan5MinutesApart(
        currentDate,
        nextDate,
      );
    }
    // Use a local copy for the DELIVERY_TIME backfill so we never mutate the
    // caller's input rows.
    let deliveryTime = item.DELIVERY_TIME;
    if (deliveryTime === "\\N") {
      deliveryTime = addMinutesToDate(
        item.CREATED_AT,
        DELIVERY_TIME_BACKFILL_MINUTES,
      );
    }
    const startTimeValid = checkIfValidDate(item.CREATED_AT);
    const endTimeValid = checkIfValidDate(deliveryTime);
    if (!startTimeValid || !endTimeValid) {
      console.warn("Invalid date format", item);
      continue;
    }
    if (isNewOrder) {
      currentInterval = {
        label: item.STORE_NAME,
        startTime: new Date(item.CREATED_AT).toISOString(),
        endTime: new Date(deliveryTime).toISOString(),
      };

      if (colorMatchObject[item.STORE_NAME]) {
        currentInterval.primaryColor =
          colorMatchObject[item.STORE_NAME].primaryColor;
        currentInterval.secondaryColor =
          colorMatchObject[item.STORE_NAME].secondaryColor;
      } else {
        const primaryColor = generate_random_color("color");
        const secondaryColor = generate_random_color("shade");
        colorMatchObject[item.STORE_NAME] = {
          primaryColor: primaryColor,
          secondaryColor: secondaryColor,
        };

        currentInterval.primaryColor = primaryColor;
        currentInterval.secondaryColor = secondaryColor;
      }
      runningDescription =
        "<li>" + item.ITEM + " – $" + item.UNIT_PRICE + "</li>";
      runningPrice = Number(item.UNIT_PRICE) || 0;
    } else {
      runningDescription +=
        "<li>" + item.ITEM + " – $" + item.UNIT_PRICE + "</li>";
      runningPrice += Number(item.UNIT_PRICE) || 0;
    }
    if (nextOrderIsNew && currentInterval) {
      const totalString =
        "<hr /><p className='_margin-top--1rem'>Total: $" +
        runningPrice.toFixed(2) +
        "</p>";
      currentInterval.description =
        "<ul className='_margin-bottom--1rem'>" +
        runningDescription +
        "</ul>" +
        totalString;
      const intervalValid = validateFileInterval(
        currentInterval,
        setFileError,
        index,
      );
      if (intervalValid) {
        timelineDataObject.push(currentInterval);
      } else {
        // Mirror the sibling adapters (e.g. Netflix): count intervals that fail
        // validation so the caller can surface how many rows were dropped.
        errors += 1;
        console.warn("Invalid interval", currentInterval);
      }
      //validateInterval(currentInterval);
      currentInterval = null;
    }
    //await blockerFunction(1);
  }
  const returnValue = {
    errors,
    intervals: timelineDataObject,
    totalSpent,
  };
  return returnValue;
};
